export default "__VITE_ASSET__DkO__6s2__"